export default "__VITE_ASSET__b8187713__"